import {
  Component,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-table-filter-text',
  imports: [InputTextModule, ReactiveFormsModule],
  templateUrl: './table-filter-text.component.html',
  styleUrls: ['./table-filter-text.component.scss'],
})
export class TableFilterTextComponent implements OnInit, OnDestroy {
  private readonly builder = inject(FormBuilder);

  @Output() public readonly changes = new EventEmitter<string>();

  public control!: FormControl<string>;

  private readonly destroy$ = new Subject<void>();

  public ngOnInit(): void {
    this.configureControl();
    this.configureValueChangesSource();
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  private configureControl(): void {
    this.control = this.builder.nonNullable.control('');
  }

  private configureValueChangesSource(): void {
    this.control.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => this.changes.emit(value));
  }
}
